var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.285 9H17.715C12.255 9 9 12.255 9 17.715V30.27C9 35.745 12.255 39 17.715 39H30.27C35.73 39 38.985 35.745 38.985 30.285V17.715C39 12.255 35.745 9 30.285 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6298 17.7146V30.2846C30.6298 31.2446 29.8498 32.0246 28.8898 32.0246C27.9148 32.0246 27.1348 31.2446 27.1348 30.2846V17.7146C27.1348 16.7546 27.9148 15.9746 28.8898 15.9746C29.8498 15.9746 30.6298 16.7546 30.6298 17.7146Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8651 25.3943V30.2843C20.8651 31.2443 20.0851 32.0243 19.1101 32.0243C18.1501 32.0243 17.3701 31.2443 17.3701 30.2843V25.3943C17.3701 24.4343 18.1501 23.6543 19.1101 23.6543C20.0851 23.6543 20.8651 24.4343 20.8651 25.3943Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart2);
export default __webpack_public_path__ + "static/media/chart2.6df30381c122bc06b490ca46703a93a0.svg";
export { ForwardRef as ReactComponent };